import { Box, Checkbox, FormControlLabel, Radio } from "@mui/material";
import { Trans } from "react-i18next";
import { convertPxToRem } from "@/utils";

interface QuestionOptionProps {
  value: string;
  translationKey: string;
  isSelected: boolean;
  showCheckbox: boolean;
  strengthTrainingChecked: boolean;
  onStrengthTrainingChange: (checked: boolean) => void;
}

export default function QuestionOption({
  value,
  translationKey,
  isSelected,
  showCheckbox,
  strengthTrainingChecked,
  onStrengthTrainingChange,
}: QuestionOptionProps) {
  return (
    <Box>
      <FormControlLabel
        sx={{
          marginTop: 2,
          alignItems: "flex-start",
          "& .MuiFormControlLabel-label": {
            paddingTop: 0.75,
          },
        }}
        value={value}
        control={
          <Radio
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize: 25,
              },
              "&:not(.Mui-checked) .MuiSvgIcon-root": {
                color: "primary.100",
              },
            }}
          />
        }
        label={
          <Trans
            i18nKey={translationKey as any}
            components={{
              strong: <strong />,
              span: <span />,
            }}
          />
        }
      />
      {showCheckbox && isSelected && (
        <FormControlLabel
          control={
            <Checkbox
              checked={strengthTrainingChecked}
              onChange={(e) => onStrengthTrainingChange(e.target.checked)}
              sx={{
                "&:not(.Mui-checked) .MuiSvgIcon-root": {
                  color: "primary.100",
                },
              }}
            />
          }
          label={
            <Trans
              i18nKey="Lifestyle.questionnaire.intense_exercise.strengthTraining"
              as
              any
              components={{
                span: <span />,
              }}
            />
          }
          sx={{
            ml: 4,
            mt: convertPxToRem(4),
            display: "flex",
            alignItems: "flex-start",
            "& .MuiFormControlLabel-label": {
              paddingTop: convertPxToRem(9),
              fontSize: convertPxToRem(16),
              color: "neutral.main",
            },
            "& .MuiFormControlLabel-label span": {
              fontSize: convertPxToRem(14),
              display: "block",
            },
          }}
        />
      )}
    </Box>
  );
}
